<template>
  <div class="sound-button">
    <span class="sound-button__label">{{item.label}}</span>

    <button class="sound-button__button" :class="{active: active}" @click="play">
      <img class="sound-button__thumb" :src="item.thumb" width="140" height="140">
      <span class="sound-button__button-label">Play sound!</span>
    </button>

    <audio class="sound-button__media" preload="auto" volume="1.0">
      <source :src="item.mp3" type="audio/mpeg"/>
      <source :src="item.ogg" type="audio/ogg"/>
    </audio>

  </div>

</template>

<script>
  // import Vue from 'vue'
  export default {
    props: ['item'],
    data: function () {
      return {
        active: false
      }
    },
    computed: {
      $audio: function () {
        return this.$el.querySelector('.sound-button__media')
      }
    },
    mounted: function () {
      this.$audio.addEventListener('pause', _ => {
        this.active = false
      })
      this.$audio.addEventListener('ended', _ => {
        this.active = false
      })
      this.$audio.addEventListener('error', _ => {
        this.active = false
      })
      this.$audio.addEventListener('play', _ => {
        this.active = true
      })
    },
    methods: {
      play: function () {
        console.dir(this.$audio)
        if (this.$audio.paused) {
          this.$audio.play()
        } else {
          this.$audio.pause()
        }
      }
    }
  }
</script>

<style>
  .sound-button {
    /*border: thin solid #444;*/
    align-items: center;
    display: flex;
    flex: 1 1 auto;
    flex-flow: column-reverse nowrap;
    justify-content: center;
    padding: 5px 0;
    margin-left: -1px;
    margin-top: -1px;
    width: 95px;
  }

  @media screen and (min-width: 450px) {
    .sound-button {
      padding: 10px;
      width: 145px;
    }
  }

  @media screen and (min-width: 1200px) {
    .sound-button {
      padding: 20px 10px;
      width: 280px;
    }
  }

  .sound-button__button {
    background: radial-gradient(circle at center, #ff5f64 0, red 50%, #ff787b 60%, red 65%, red 85%, black 85%, black 100%);
    /*border: 5px solid #c0c0c0;*/
    border: 5px solid #444;
    border-radius: 50%;
    cursor: pointer;
    height: 100px;
    outline: 0;
    padding: 0;
    position: relative;
    width: 100px;
  }

  .sound-button__button::before {
    bottom: 0;
    color: #fff;
    content: "PUSH";
    font-size: 16px;
    font-weight: 700;
    height: 1em;
    left: 0;
    line-height: 1;
    margin: auto;
    opacity: 0.8;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 2;
  }

  @media screen and (min-width: 450px) {
    .sound-button__button {
      height: 140px;
      width: 140px;
    }

    .sound-button__button::before {
      font-size: 24px;
    }
  }

  @media screen and (min-width: 1200px) {
    .sound-button__button {
      height: 270px;
      width: 270px;
    }

    .sound-button__button::before {
      font-size: 42px;
    }
  }

  .sound-button__button:focus,
  .sound-button__button:hover {
    background: radial-gradient(circle at center, #eb5f64 0, #eb0000 50%, #f5777a 60%, #eb0000 65%, #eb0000 85%, black 85%, black 100%);
  }

  .sound-button__button:focus::before,
  .sound-button__button:hover::before {
    opacity: 1;
  }

  .sound-button__button:active {
    background: radial-gradient(circle at center, #cd2b33 0, #9b0000 50%, #9b4e4e 60%, #9b0000 65%, #9b0000 85%, black 85%, black 100%);
  }

  .sound-button__thumb {
    border-radius: 50%;
    height: 90px;
    width: 90px;
    display: none;
  }

  @media screen and (min-width: 450px) {
    .sound-button__thumb {
      height: 130px;
      width: 130px;
    }
  }

  @media screen and (min-width: 1200px) {
    .sound-button__thumb {
      height: 260px;
      width: 260px;
    }
  }

  .sound-button__button.active {
    /*transition: background 0.225s 0s ease-out;*/
    background: transparent;
  }

  .sound-button__button.active::before {
    display: none;
  }

  .sound-button__button.active .sound-button__thumb {
    display: block;
  }

  .sound-button__button-label {
    display: none;
    overflow: hidden;
    position: absolute;
    text-indent: 100%;
    padding: 0;
    white-space: nowrap;
  }

  .sound-button__label {
    background: #000;
    border: 2px dotted #555;
    /*display: block;*/
    display: none;
    color: red;
    flex: 0 1 auto;
    font-family: "Comic Sans MS", Chalkboard, Helvetica, Arial, script;
    font-size: 14px;
    line-height: 24px;
    text-transform: uppercase;
    padding: 0.25em 0.5em;
  }

  .sound-button__media {
    position: absolute;
  }

</style>



// WEBPACK FOOTER //
// src/components/SoundButton.vue